// API Keys
export const GOOGLE_MAPS_API_KEY: string = 'AIzaSyC9hBgMN6w00qrn7sHPGKXDBsaKwlPf6ME';
export const GEOAPIFY_API_KEY: string = '5efaaa560bc94af3ae76b23aa4233cf0';

interface Location {
  lat: number;
  lng: number;
}

interface PlaceTypeOption {
  value: string;
  label: string;
}

interface PlaceTypeCategory {
  label: string;
  options: PlaceTypeOption[];
}

// Default map location (Lilla Essingen, Stockholm)
export const DEFAULT_LOCATION: Location = { lat: 59.3247, lng: 18.0053 };

// Place types organized by category
export const PLACE_TYPE_CATEGORIES: PlaceTypeCategory[] = [
  {
    label: 'Mat & Dryck',
    options: [
      { value: 'restaurant', label: 'Restauranger' },
      { value: 'cafe', label: 'Kaféer' },
      { value: 'bar', label: 'Barer' },
      { value: 'bakery', label: 'Bagerier' },
      { value: 'meal_delivery', label: 'Matleverans' },
      { value: 'meal_takeaway', label: 'Takeaway' },
      { value: 'systembolaget', label: 'Systembolaget' },
      { value: 'grocery_or_supermarket', label: 'Livsmedelsbutiker' },
      { value: 'food', label: 'Mat (Allmänt)' }
    ]
  },
  {
    label: 'Shopping',
    options: [
      { value: 'shopping_mall', label: 'Köpcentrum' },
      { value: 'department_store', label: 'Varuhus' },
      { value: 'convenience_store', label: 'Närbutiker' },
      { value: 'clothing_store', label: 'Klädbutiker' },
      { value: 'shoe_store', label: 'Skobutiker' },
      { value: 'jewelry_store', label: 'Juvelerare' },
      { value: 'book_store', label: 'Bokhandlare' },
      { value: 'electronics_store', label: 'Elektronikbutiker' },
      { value: 'hardware_store', label: 'Järnhandel' },
      { value: 'home_goods_store', label: 'Heminredning' },
      { value: 'furniture_store', label: 'Möbelaffärer' },
      { value: 'bicycle_store', label: 'Cykelbutiker' },
      { value: 'pet_store', label: 'Djuraffärer' },
      { value: 'store', label: 'Butiker (Allmänt)' }
    ]
  },
  {
    label: 'Tjänster & Bekvämligheter',
    options: [
      { value: 'atm', label: 'Bankomater' },
      { value: 'bank', label: 'Banker' },
      { value: 'post_office', label: 'Postkontor' },
      { value: 'laundry', label: 'Tvätteri' },
      { value: 'dry_cleaning', label: 'Kemtvätt' },
      { value: 'hair_care', label: 'Frisörer' },
      { value: 'beauty_salon', label: 'Skönhetssalonger' },
      { value: 'spa', label: 'Spa' },
      { value: 'insurance_agency', label: 'Försäkringsbolag' },
      { value: 'accounting', label: 'Redovisning' },
      { value: 'lawyer', label: 'Advokater' },
      { value: 'locksmith', label: 'Låssmeder' },
      { value: 'real_estate_agency', label: 'Mäklare' },
      { value: 'storage', label: 'Förråd' },
      { value: 'moving_company', label: 'Flyttfirmor' },
      { value: 'finance', label: 'Finansiella tjänster' }
    ]
  },
  {
    label: 'Hälsa & Sjukvård',
    options: [
      { value: 'hospital', label: 'Sjukhus' },
      { value: 'pharmacy', label: 'Apotek' },
      { value: 'doctor', label: 'Läkare' },
      { value: 'dentist', label: 'Tandläkare' },
      { value: 'physiotherapist', label: 'Fysioterapeuter' },
      { value: 'health', label: 'Hälsa (Allmänt)' },
      { value: 'veterinary_care', label: 'Veterinärvård' },
      { value: 'coronavirus_testing_site', label: 'Covid-testplatser' },
      { value: 'vaccination_site', label: 'Vaccinationsplatser' },
      { value: 'psychologist', label: 'Psykologer' },
      { value: 'mental_health', label: 'Psykisk hälsa' },
      { value: 'medical_clinic', label: 'Vårdcentraler' },
      { value: 'optician', label: 'Optiker' }
    ]
  },
  {
    label: 'Utbildning',
    options: [
      { value: 'school', label: 'Skolor' },
      { value: 'university', label: 'Universitet' },
      { value: 'library', label: 'Bibliotek' },
      { value: 'primary_school', label: 'Grundskolor' },
      { value: 'secondary_school', label: 'Gymnasieskolor' },
      { value: 'preschool', label: 'Förskolor' }
    ]
  },
  {
    label: 'Transport',
    options: [
      { value: 'transit_station', label: 'Kollektivtrafikstationer' },
      { value: 'subway_station', label: 'Tunnelbanestationer' },
      { value: 'train_station', label: 'Tågstationer' },
      { value: 'bus_station', label: 'Busstationer' },
      { value: 'taxi_stand', label: 'Taxistationer' },
      { value: 'gas_station', label: 'Bensinstationer' },
      { value: 'car_rental', label: 'Biluthyrning' },
      { value: 'car_repair', label: 'Bilverkstäder' },
      { value: 'car_wash', label: 'Biltvättar' },
      { value: 'car_dealer', label: 'Bilhandlare' },
      { value: 'parking', label: 'Parkering' },
      { value: 'electric_vehicle_charging_station', label: 'Laddstationer' },
      { value: 'airport', label: 'Flygplatser' }
    ]
  },
  {
    label: 'Boende',
    options: [
      { value: 'lodging', label: 'Boende (Allmänt)' },
      { value: 'hotel', label: 'Hotell' },
      { value: 'campground', label: 'Campingplatser' },
      { value: 'rv_park', label: 'Husvagnsparker' }
    ]
  },
  {
    label: 'Nöje & Fritid',
    options: [
      { value: 'amusement_park', label: 'Nöjesparker' },
      { value: 'movie_theater', label: 'Biografer' },
      { value: 'night_club', label: 'Nattklubbar' },
      { value: 'casino', label: 'Kasinon' },
      { value: 'bowling_alley', label: 'Bowlinghallar' },
      { value: 'zoo', label: 'Djurparker' },
      { value: 'aquarium', label: 'Akvarier' },
      { value: 'museum', label: 'Museer' },
      { value: 'art_gallery', label: 'Konstgallerier' },
      { value: 'stadium', label: 'Arenor' },
      { value: 'park', label: 'Parker' },
      { value: 'tourist_attraction', label: 'Turistattraktioner' },
      { value: 'gym', label: 'Gym' },
      { value: 'fitness_center', label: 'Träningscenter' },
      { value: 'swimming_pool', label: 'Simhallar' }
    ]
  },
  {
    label: 'Religiösa platser',
    options: [
      { value: 'place_of_worship', label: 'Andaktslokaler' },
      { value: 'church', label: 'Kyrkor' },
      { value: 'mosque', label: 'Moskéer' },
      { value: 'hindu_temple', label: 'Hindutempel' },
      { value: 'synagogue', label: 'Synagogor' },
      { value: 'buddhist_temple', label: 'Buddhisttempel' }
    ]
  },
  {
    label: 'Offentlig service',
    options: [
      { value: 'police', label: 'Polisstationer' },
      { value: 'fire_station', label: 'Brandstationer' },
      { value: 'courthouse', label: 'Domstolar' },
      { value: 'town_hall', label: 'Kommunhus' },
      { value: 'city_hall', label: 'Stadshus' },
      { value: 'local_government_office', label: 'Kommunala kontor' },
      { value: 'embassy', label: 'Ambassader' }
    ]
  },
  {
    label: 'Övrigt',
    options: [
      { value: 'cemetery', label: 'Kyrkogårdar' },
      { value: 'funeral_home', label: 'Begravningsbyråer' },
      { value: 'travel_agency', label: 'Resebyråer' },
      { value: 'roofing_contractor', label: 'Takläggare' },
      { value: 'general_contractor', label: 'Byggentreprenörer' },
      { value: 'plumber', label: 'Rörmokare' },
      { value: 'electrician', label: 'Elektriker' },
      { value: 'florist', label: 'Blomsterbutiker' },
      { value: 'natural_feature', label: 'Naturfenomen' },
      { value: 'point_of_interest', label: 'Sevärdheter' },
      { value: 'business', label: 'Företag (Allmänt)' },
      { value: 'establishment', label: 'Inrättningar' }
    ]
  }
];
